// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".company-info_form[data-v-013ab1a0] {\n  padding: 0 60px 60px 20px;\n}\n.el-icon-plus[data-v-013ab1a0] {\n  margin-top: -12px;\n  float: right;\n}\n.model-editor[data-v-013ab1a0] {\n  margin-top: 80px;\n}", ""]);
// Exports
module.exports = exports;
